export default __webpack_public_path__ + "762ce76f4387c0ac8a1f4b28bec09771.svg";